export default {
  account_001: '/user/family',
  town_infirmary_001: '/staff/town-infirmary',
  account_002: '/cafe',
  skillshare_003: '/cafe',
  general_001: '/cafe',
  cafe_003: '/cafe',
  sharebox_001: '/cafe',
}
